module.exports = __webpack_public_path__ + "img/gntech_gallery5.c775bf93.jpg";